const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.44 382.29 181.98 382.29 181.98 296.83 190.55 296.83 187.44 382.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,318.23c.34,0,.67-.06,1-.06a14.69,14.69,0,0,1,6.71,1.89l.85-23.23H182Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.72 382.29 160.25 382.29 160.25 296.83 168.82 296.83 165.72 382.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,327.49c2.56.4,5-.52,7.52-1.92l1-28.74h-8.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.75 382.29 322.22 382.29 322.22 296.83 313.65 296.83 316.75 382.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,318.23c-.34,0-.67-.06-1-.06a14.69,14.69,0,0,0-6.71,1.89l-.85-23.23h8.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.49 382.29 343.95 382.29 343.95 296.83 335.38 296.83 338.49 382.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,327.49c-2.56.4-5-.52-7.52-1.92l-1.05-28.74H344Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.2,280.13c15.9,5.91,20.24,31.29,0,34.52-7.59,1.22-14.56-9.31-22.75-9.31s-14.55,9.31-22.74,9.31-14.56-9.31-22.74-9.31-14.56,9.31-22.75,9.31-14.55-9.31-22.74-9.31-14.56,9.31-22.74,9.31-14.56-9.31-22.75-9.31-15.15,10.53-22.74,9.31c-20.24-3.23-17.24-29.23,0-34.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46,243.59V232.22a1.6,1.6,0,0,0-1.59-1.6h-1.55a1.6,1.6,0,0,0-1.59,1.6v11.37l-2,3.4a11.65,11.65,0,0,0-1.66,6v25.44a2.08,2.08,0,0,0,2.08,2.08h8a2.08,2.08,0,0,0,2.08-2.08V253a11.66,11.66,0,0,0-1.67-6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.87,262.93c0,9,.17,16.36-.45,16.36s-1.13-7.33-1.13-16.36,1.18-16.36,1.8-16.36S290.87,253.89,290.87,262.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,238c0,3.18-.32,5.76-.72,5.76s-.1-2.58-.1-5.76.32-5.76.72-5.76S292.48,234.85,292.48,238Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.78,247.79V237.71a1.41,1.41,0,0,0-1.41-1.41H225a1.41,1.41,0,0,0-1.41,1.41v10.08l-1.81,3a10.41,10.41,0,0,0-1.47,5.33v22.55a1.84,1.84,0,0,0,1.84,1.84h7.07a1.84,1.84,0,0,0,1.85-1.84V256.13a10.32,10.32,0,0,0-1.48-5.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,264.93c0,8,.15,14.5-.4,14.5s-1-6.49-1-14.5,1-14.5,1.59-14.5S223.7,256.92,223.7,264.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.13,242.87c0,2.82-.28,5.1-.64,5.1s-.09-2.28-.09-5.1.29-5.11.64-5.11S225.13,240.05,225.13,242.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.66,239.3V226.6a1.78,1.78,0,0,0-1.78-1.77h-1.73a1.78,1.78,0,0,0-1.78,1.77v12.7l-2.27,3.79a13,13,0,0,0-1.86,6.71v28.4a2.32,2.32,0,0,0,2.32,2.32h8.91a2.32,2.32,0,0,0,2.32-2.32V249.8a13,13,0,0,0-1.86-6.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,260.89c0,10.08.2,18.25-.5,18.25s-1.25-8.17-1.25-18.25,1.31-18.26,2-18.26S207.52,250.8,207.52,260.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.33,233.09c0,3.56-.36,6.44-.81,6.44s-.11-2.88-.11-6.44.36-6.43.8-6.43S209.33,229.54,209.33,233.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.83,275.81v-9.69a2.07,2.07,0,0,1,1.4-2,8.09,8.09,0,0,0,5.41-7.75,8.33,8.33,0,0,0-2-5.47H303.29a8.33,8.33,0,0,0-2,5.47,8.09,8.09,0,0,0,5.41,7.75,2.07,2.07,0,0,1,1.4,2v9.69a2.11,2.11,0,0,1-1.76,2.08c-1.75.29-2.94.86-2.94,1.51,0,.94,2.5,1.12,5.57,1.12s5.58-.18,5.58-1.12c0-.65-1.19-1.22-2.94-1.51A2.11,2.11,0,0,1,309.83,275.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,255.69a5.36,5.36,0,0,0-.06.69,6.48,6.48,0,0,0,4.34,6.26A3.64,3.64,0,0,1,309,264a3.57,3.57,0,0,1,1.78-1.31,6.48,6.48,0,0,0,4.34-6.26,5.36,5.36,0,0,0-.06-.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.3,275.81v-9.69a2.07,2.07,0,0,1,1.4-2,8.09,8.09,0,0,0,5.41-7.75,8.33,8.33,0,0,0-2-5.47H185.76a8.33,8.33,0,0,0-2,5.47,8.09,8.09,0,0,0,5.41,7.75,2.07,2.07,0,0,1,1.4,2v9.69a2.11,2.11,0,0,1-1.76,2.08c-1.75.29-2.94.86-2.94,1.51,0,.94,2.5,1.12,5.57,1.12s5.58-.18,5.58-1.12c0-.65-1.19-1.22-2.94-1.51A2.11,2.11,0,0,1,192.3,275.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,263.39a493,493,0,0,1,6.15,54.2l2.86-.24a496.9,496.9,0,0,0-6.2-54.56C98.6,251.14,87,242,75.79,242.8A17.3,17.3,0,0,0,63,250,18.68,18.68,0,0,0,60,264.83a445.51,445.51,0,0,1,6.29,49.23l2.86-.2a452.05,452.05,0,0,0-6.34-49.59,15.77,15.77,0,0,1,2.44-12.52,12.16,12.16,0,0,1,1.12-1.35,443,443,0,0,1,9.26,64.54l2.85-.21a434.07,434.07,0,0,0-9.67-66.42,15,15,0,0,1,6-2.35A442.56,442.56,0,0,1,85,315.82l2.86-.21a446.27,446.27,0,0,0-10.09-69.88,18.61,18.61,0,0,1,6.94,1.5,454.44,454.44,0,0,1,9.63,69.47l2.86-.22A458.72,458.72,0,0,0,88.06,249,22.32,22.32,0,0,1,97.51,263.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.84,308.53h52.64a6.59,6.59,0,0,1,6.59,6.59v.41a0,0,0,0,1,0,0H66.25a0,0,0,0,1,0,0v-.41A6.59,6.59,0,0,1,72.84,308.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.48 382.29 64.98 382.29 67.84 315.53 72.29 315.53 68.48 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.85 382.29 88.35 382.29 90.26 315.53 94.71 315.53 91.85 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.97 382.29 106.47 382.29 103.61 315.53 108.06 315.53 109.97 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.34 382.29 129.84 382.29 126.02 315.53 130.47 315.53 133.34 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.82,
    y: 312.98,
    width: 39.11,
    height: 5.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.38,
    y: 312.98,
    width: 32.44,
    height: 5.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,263.39a493,493,0,0,0-6.15,54.2l-2.86-.24a496.9,496.9,0,0,1,6.2-54.56c1.72-11.65,13.36-20.75,24.53-20A17.3,17.3,0,0,1,437,250a18.68,18.68,0,0,1,2.94,14.8,445.51,445.51,0,0,0-6.29,49.23l-2.86-.2a452.05,452.05,0,0,1,6.34-49.59,15.77,15.77,0,0,0-2.44-12.52,12.16,12.16,0,0,0-1.12-1.35,443,443,0,0,0-9.26,64.54l-2.85-.21a434.07,434.07,0,0,1,9.67-66.42,15,15,0,0,0-6-2.35A442.56,442.56,0,0,0,415,315.82l-2.86-.21a446.27,446.27,0,0,1,10.09-69.88,18.61,18.61,0,0,0-6.94,1.5,454.44,454.44,0,0,0-9.63,69.47l-2.86-.22A458.72,458.72,0,0,1,411.94,249,22.32,22.32,0,0,0,402.49,263.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.94,308.53h65.81a0,0,0,0,1,0,0v.41a6.59,6.59,0,0,1-6.59,6.59H374.53a6.59,6.59,0,0,1-6.59-6.59v-.41A0,0,0,0,1,367.94,308.53Z",
    transform: "translate(801.69 624.06) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.52 382.29 435.02 382.29 432.16 315.53 427.71 315.53 431.52 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.15 382.29 411.65 382.29 409.74 315.53 405.29 315.53 408.15 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.03 382.29 393.53 382.29 396.39 315.53 391.94 315.53 390.03 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.66 382.29 370.16 382.29 373.98 315.53 369.52 315.53 366.66 382.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.07,
    y: 312.98,
    width: 39.11,
    height: 5.09,
    transform: "translate(769.25 631.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.18,
    y: 312.98,
    width: 32.44,
    height: 5.09,
    transform: "translate(840.8 631.05) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74,139.94s12.53-17,29.51-17,27.92,17,27.92,17V230.8H147.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,140.59c-7.33-9.88-16.95-15.31-27.18-15.31s-19.85,5.43-27.17,15.31v88.49h54.35ZM202,226.71h-51V141.6c6.94-9,16-14,25.48-14s18.55,5,25.48,14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,233.21H146.4V138.87l.44-.61c7.94-11,18.49-17.12,29.71-17.12s21.78,6.08,29.72,17.12l.43.61Zm-57.32-4.13h54.35V140.59c-7.33-9.88-16.95-15.31-27.18-15.31s-19.85,5.43-27.17,15.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,228V187.12h15.5V183h-15.5V142.3h15.5V141c-.74-1-1.51-1.92-2.3-2.81h-13.2V128.4q-1.47-.6-3-1.05v10.81H168.48V127.35q-1.5.45-3,1.05v9.76h-13.2c-.79.89-1.56,1.82-2.3,2.81v1.33h15.5V183H150v4.14h15.5V228h3V187.12h16.14V228Zm-3-45H168.48V142.3h16.14Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.32,139.94s12.53-17,29.51-17,27.92,17,27.92,17V230.8H297.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.31,140.59c-7.32-9.88-16.95-15.31-27.18-15.31s-19.85,5.43-27.17,15.31v88.49h54.35Zm-1.7,86.12H300.66V141.6c6.93-9,15.95-14,25.47-14s18.55,5,25.48,14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.28,233.21H296V138.87l.43-.61c7.94-11,18.49-17.12,29.71-17.12s21.78,6.08,29.72,17.12l.43.61ZM299,229.08h54.35V140.59c-7.32-9.88-16.95-15.31-27.18-15.31s-19.85,5.43-27.17,15.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,228V187.12h15.5V183h-15.5V142.3h15.5V141c-.74-1-1.51-1.92-2.29-2.81H337.17V128.4c-1-.4-2-.75-3-1.05v10.81H318.07V127.35c-1,.3-2,.65-3,1.05v9.76h-13.2c-.78.89-1.55,1.82-2.3,2.81v1.33h15.5V183h-15.5v4.14h15.5V228h3V187.12H334.2V228Zm-3-45H318.07V142.3H334.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.79,298.18s9.15,5,20.73-4.67h0V281.4l-21.89-.24,1.13,16.36Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-62",
    cx: 251.9,
    cy: 410.97,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.34 373.22 395.59 401.28 403.06 401.3 403.71 371.89 392.34 373.22",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,399.44c5.36,3.05,6,3.12,11.86,4.33,1.3.27.81,3.35-2.2,3.38-5,.08-4.55-.1-8.8,0-3.62,0-8.87.24-11.75.32H395a1.26,1.26,0,0,1-1.15-1.3l.54-6.63a.56.56,0,0,1,.56-.52l9.18-.07A3.5,3.5,0,0,1,405.93,399.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,399.56c1.19.23,3.32.5,4.11-.24a1,1,0,0,0,.31-.87h0a.58.58,0,0,0-.31-.47c-.91-.48-3.84,1.06-4.17,1.24a.17.17,0,0,0,0,.32Zm3.95-1.27a.22.22,0,0,1,.12.18.62.62,0,0,1-.2.58c-.44.41-1.66.5-3.3.24,1.16-.58,2.76-1.22,3.32-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.55,399.56c.88-.42,2.61-2,2.45-2.91,0-.21-.19-.45-.67-.5h0a1.29,1.29,0,0,0-1,.32c-.92.8-1.06,2.82-1.06,2.9a.19.19,0,0,0,.08.17h0A.2.2,0,0,0,405.55,399.56Zm1.94-3c.15,0,.16.13.16.16.1.52-1.07,1.8-2,2.37a4.12,4.12,0,0,1,.92-2.33.88.88,0,0,1,.71-.23h.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.86 381.43 390.69 404.56 399.06 404.56 390.2 376.5 379.86 381.43",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,402.87c5.36,3.06,6,3.12,11.86,4.34,1.3.26.81,3.34-2.2,3.37-5,.08-4.55-.09-8.8-.05-3.62,0-8.86.25-11.74.32H389a1.25,1.25,0,0,1-1.14-1.29l.53-6.64a.58.58,0,0,1,.57-.52l9.17-.07A3.68,3.68,0,0,1,400,402.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.47,403c1.2.23,3.32.5,4.11-.24a1,1,0,0,0,.31-.86h0a.6.6,0,0,0-.3-.48c-.92-.48-3.85,1.06-4.17,1.24a.17.17,0,0,0-.09.18.14.14,0,0,0,.12.14Zm4-1.26a.19.19,0,0,1,.11.18.61.61,0,0,1-.2.57c-.44.42-1.66.51-3.3.24,1.16-.57,2.76-1.21,3.32-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,403c.87-.42,2.61-2,2.44-2.91,0-.2-.18-.45-.67-.49h0a1.25,1.25,0,0,0-1,.32c-.92.79-1.07,2.82-1.06,2.9a.16.16,0,0,0,.07.16h.05A.15.15,0,0,0,399.58,403Zm1.93-3a.2.2,0,0,1,.17.17c.09.51-1.07,1.79-2,2.36a4.21,4.21,0,0,1,.91-2.33.93.93,0,0,1,.71-.23h.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7,215.79a2.46,2.46,0,0,0,2.57-2.58l-.58-27.56c-.08-1.74-.43-4.37-.43-4.37,4,.65,11,2.62,12.94,10.3,2,8,1.54,23.68.71,31.22-.4,3.63-3.28,8.3-9.62,7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.94,189.68c-2.22,19.54-6.74,30.85-6.28,46.53l-36.86-.62c.24-28.87-3.86-23.54-4.29-39.24-.06-6,.1-13.57,3.56-14.08l20.9-4.15,17,3.4A7.46,7.46,0,0,1,378.94,189.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.94,189.68c-2.22,19.54-6.74,30.85-6.28,46.53l-36.86-.62c.24-28.87-3.86-23.54-4.29-39.24-.06-6,.1-13.57,3.56-14.08l20.9-4.15,17,3.4A7.46,7.46,0,0,1,378.94,189.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,190.57c-6.85-.6-14.29-6.55-15-9.95,2.38-.34,3-2,3.5-4.86a29.22,29.22,0,0,0,.26-5.43c-.06-2.73-.34-5.38-.43-7.14l11.7,7c-.07.33-.15.69-.22,1.05a14.73,14.73,0,0,0-.05,5.5,5.89,5.89,0,0,0,4.92,5C367.21,183.88,366.43,188,360.9,190.57Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,191a40.21,40.21,0,0,0-14.49-2c.56-1.13,1.13-2.49,1.68-3.62-1.74,0-3.41-.16-5.16-.16a19.29,19.29,0,0,1,1.87-6.44c1.1-2,2.57-3.59,4.78-3.56-.3.77-1.06,3.62-.29,5.15a12.85,12.85,0,0,0,3.41,3.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.91,191a40.21,40.21,0,0,0-14.49-2c.56-1.13,1.13-2.49,1.68-3.62-1.74,0-3.41-.16-5.16-.16a19.29,19.29,0,0,1,1.87-6.44c1.1-2,2.57-3.59,4.78-3.56-.3.77-1.06,3.62-.29,5.15a12.85,12.85,0,0,0,3.41,3.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.67,176.31a4.56,4.56,0,0,0,1.07,2.8c.61.82,1.34,1.54,1.88,2.41A6.51,6.51,0,0,1,361,190.8c-.1,0-.1.18-.06.29a51.33,51.33,0,0,1,6.46-3.66c.66-.32,1.23-.67,1.86-1a5.6,5.6,0,0,0-2.58-3.28c1.63-.17,3.22-.58,4.84-.75-2.22-1.52-4.33-3.25-6.57-4.75C363.77,176.84,362,175.93,360.67,176.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.67,176.31a4.56,4.56,0,0,0,1.07,2.8c.61.82,1.34,1.54,1.88,2.41A6.51,6.51,0,0,1,361,190.8c-.1,0-.1.18-.06.29a51.33,51.33,0,0,1,6.46-3.66c.66-.32,1.23-.67,1.86-1a5.6,5.6,0,0,0-2.58-3.28c1.63-.17,3.22-.58,4.84-.75-2.22-1.52-4.33-3.25-6.57-4.75C363.77,176.84,362,175.93,360.67,176.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,176.72c-5-1.15-8.33-5-10.27-7.11l10.32,1.61A14.73,14.73,0,0,0,360.65,176.72Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.18,166.62c-2,6.9-10.73,9.78-15.79,4.21-2.92-3.21-3.09-6.72-3.15-12.16,0-.83,0-1.7,0-2.62a9.83,9.83,0,0,1,.84-4.18,9.11,9.11,0,0,1,.88-1.56A9.61,9.61,0,0,1,361.75,147C368.48,150,369,160.42,367.18,166.62Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,157.26c.37,0,.64.49.62,1.05s-.3,1-.71,1-.7-.49-.68-1.07S360.16,157.25,360.53,157.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,164.56l-2.67.08c-.23.53-.49,1-.72,1.54a8.23,8.23,0,0,0,5,.5,11.18,11.18,0,0,0-.48-2.21C365.18,164.5,364.71,164.55,364.38,164.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9,157.72c.37,0,.65.48.63,1s-.34,1-.72,1-.65-.48-.63-1.05S366.53,157.71,366.9,157.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.29,164.5a3.24,3.24,0,0,0,2.69-.71,20.26,20.26,0,0,1-3-4.66Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.06,167.44l-.1,0-.28-.13a4.29,4.29,0,0,0-3.39-.07.25.25,0,0,1-.19-.47,4.84,4.84,0,0,1,3.79.08l.28.13a.25.25,0,0,1,.12.33A.24.24,0,0,1,363.06,167.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,156.07a2.72,2.72,0,0,1,2.2-1h0a.16.16,0,0,0,.1,0,.34.34,0,0,0,.33-.34.34.34,0,0,0-.34-.33,3.34,3.34,0,0,0-2.77,1.25.33.33,0,0,0,0,.47.3.3,0,0,0,.15.07A.34.34,0,0,0,359.15,156.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,156.81h0a.34.34,0,0,0,.11-.46,3.24,3.24,0,0,0-2.52-1.68h0a.32.32,0,0,0-.34.31v0a.32.32,0,0,0,.32.32,2.66,2.66,0,0,1,2,1.36.31.31,0,0,0,.45.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.63,142.93a4.63,4.63,0,0,1,3.91,1.77c.14.18-.9,5.24-2,5.35a16.45,16.45,0,0,1-7.53-1,5.07,5.07,0,0,0-1.37-.33c-.47,0-2.82,2.17-3.27,3.16a12,12,0,0,0-.83,3.13,2.88,2.88,0,0,1-.28,1c-.16.29-.25.56-.58.54a5.24,5.24,0,0,0-.34,3.06,16.49,16.49,0,0,0,.9,3l.8,2.1c-.35,0-4.52-1.74-6-2.23a15.07,15.07,0,0,1-2.78-9.41c0-.94.09-3.91.55-4.74a2.92,2.92,0,0,1,2.21-1.58c-.6-2.41,1.43-3,3.74-3.9s4.91-.61,7.35-.15A23.62,23.62,0,0,0,363.63,142.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74,158.2c2.26.27,3.37,3.27,3.42,5.25.07,2.2-1.57,3.85-3.58,2.68a6.52,6.52,0,0,1-3-4A3,3,0,0,1,347.74,158.2Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,189.08c.06-8.61-11.6-8.63-13-.65,0,.08,0,.16,0,.23-1.29,8.16,1.44,27.87,3,35.3a6.64,6.64,0,0,0,7.79,5.19l23.26-4.5-1.23-11.11-15.32,2.05a2.48,2.48,0,0,1-2.8-2.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.13,222.48l5.93-1.52a3.49,3.49,0,0,1,1.64,0l5.42,1.23a3.47,3.47,0,0,0,3.26-1l2.74-2.8a3.5,3.5,0,0,0-.14-5l-.88-.81a3.49,3.49,0,0,0-4.3-.33h0a3.43,3.43,0,0,1-2.22.57l-.33,0a3.47,3.47,0,0,0-3.49,2.09l-.35.79-8.38,1Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.93,214.93l-6.06-.81a3.51,3.51,0,0,1-1.53-.6l-4.57-3.17a3.51,3.51,0,0,0-3.39-.33l-3.59,1.56a3.52,3.52,0,0,0-1.76,4.74l.52,1.08a3.48,3.48,0,0,0,3.86,1.91h0a3.43,3.43,0,0,1,2.27.31l.29.14a3.5,3.5,0,0,0,4-.63l.62-.6,8.16,2.19Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.88 214.8 350.77 213.5 349.11 221.4 355.01 222.95 356.88 214.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "356.88 214.8 350.77 213.5 349.11 221.4 355.01 222.95 356.88 214.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.14,225.39A6.66,6.66,0,0,1,376,230l-22.89-6.11,2-11L370.26,216C385.18,218,384.14,225.39,384.14,225.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.42,326.5l-4,66.3-15-.57s0-10.51-.42-25.24c-.36-12-5-28.49-2.24-41.16-14.54-26-33.37-47.1-36.41-54.63-6.28-15.58-.92-35.45-.92-35.45l23.41-.42h0A110,110,0,0,0,383,267.25l22.6,45.56A27.7,27.7,0,0,1,408.42,326.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.81 309.54 356.56 264.85 368.78 264.85 376.81 309.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.8,235.59s-6.95,17.38-2.88,33.67c2,8.1,30.77,70.25,30.77,70.25s1.7,17,11.52,36.77L385,394.6l11.76-.45-14.43-63.54L368,285c-4.35-16.28-7.8-32.8-8.4-49.64h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.35,190.21c-5.83-4.52-9.39-.36-15.33-3.69-2.88-1.61-4.69-.94-2.56-3.29l0-.06a27.79,27.79,0,0,0,3.91-6.66,19.25,19.25,0,0,0,1.25-9.36,7.78,7.78,0,0,1,1.26-4.94h0c3.25.57,7.41,0,8.87,3a36.38,36.38,0,0,1,1.81,10.52l-1.8-1.32c.91,2.28,1.79,3.85,2.5,5.28C272.44,181.94,271.52,186.36,271.35,190.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,195.77c2.66-2.64,2-14.89,2-14.89l7.43,5.36s.24,7.57,2,9.08c.42.36,1.05.09,1.56.13l-.52,1.91-1.48,2.35-2,1.33-2.87-.09-2.55-.81L251.28,198l-2.35-2C249.49,195.93,250.21,196.15,250.6,195.77Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,188.35c-5-.71-7.18-3.36-8.16-5.43l.27-2,7.43,5.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,177.78v.13c0,.42,0,.85-.05,1.25a10.61,10.61,0,0,1-.16,1.15,8,8,0,0,1-8.72,6.28H260a9.34,9.34,0,0,1-4.68-1.82,12.19,12.19,0,0,1-1.82-1.59,9.58,9.58,0,0,1-.9-1.14l-.16-.24c-.18-.29-.34-.57-.49-.87-.08-.15-.15-.31-.22-.47a.33.33,0,0,1,0-.06l-.14-.34a31.11,31.11,0,0,1-1.3-4.51c0-.14-.07-.29-.11-.44l0-.17c-.14-.62-.28-1.28-.44-2a8.82,8.82,0,0,1,10.24-10.74l.4.08c3.05.69,5.2,3,6.6,5.9a8.31,8.31,0,0,1,.39.87c.05.1.09.2.13.3a22.1,22.1,0,0,1,1,3.39,1.85,1.85,0,0,1,0,.23,17.41,17.41,0,0,1,.35,2.34A19.13,19.13,0,0,1,269,177.78Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.66,172.35c.08.52-.13,1-.46,1s-.69-.32-.78-.85a1,1,0,0,1,.33-1h.05l1.14-.54s-.23.53-.61.66A1.18,1.18,0,0,1,265.66,172.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,173.55a14.1,14.1,0,0,0,2.93,2.52,2.32,2.32,0,0,1-1.65,1Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,172.19a.31.31,0,0,0,.29-.22A3.7,3.7,0,0,1,260.1,170a.32.32,0,0,0,.21-.39.31.31,0,0,0-.38-.21h0a4.2,4.2,0,0,0-2.62,2.34.3.3,0,0,0,.2.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.37,169.06a.3.3,0,0,0,.27-.16.31.31,0,0,0-.11-.43,3,3,0,0,0-2.85-.2.3.3,0,0,0-.15.39v0a.31.31,0,0,0,.41.14h0a2.45,2.45,0,0,1,2.23.19A.37.37,0,0,0,267.37,169.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.77,173.42c.09.52-.13,1-.46,1.05s-.68-.33-.78-.86.15-1,.48-1.05h.07l1-.45a1.42,1.42,0,0,1-.6.64A1.12,1.12,0,0,1,259.77,173.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,214.56,238,224.48c-1.21,2.91.1,7.25,1.4,10.28,2.95,6.83,7.52,17.61,7.52,17.61-.82,2.48-5.1,1.89-5.1,1.89s-7.72-11.89-10.94-23.54c-2.14-7.72,3.27-25.08,8-31.49,1.44-1.95,6.08-5.16,6.08-5.16l-.91,21.58Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,251l3.16,2.05a.83.83,0,0,1,.27.26l2.65,3.79a1,1,0,0,1,.17.69l-.22,1.66a.81.81,0,0,1-.42.64L246,262.48a.89.89,0,0,1-1.19-.44l-2.6-5.23a1.39,1.39,0,0,1-.1-.33l-.44-3.71a.88.88,0,0,1,.45-.89L244,251A.85.85,0,0,1,244.84,251Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,249.44l-27.88-5.62s4.23-7-1.65-33.2c-2.69-12,2.15-18.36,11.53-19.16.44-.05.87-.07,1.32-.09,3.8-.13,8.63,2.92,11.61,5.2,0,0,0,0,.05,0,.93,1,1.82,2.07,2.88,3.22,8.72,9.47,1,17.41,1.76,40.65,0,.2,0,.41,0,.62A48.31,48.31,0,0,0,270.24,249.44Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,157.59a6.54,6.54,0,0,0-5.46.66,12,12,0,0,0-3.93,4,21,21,0,0,0-2.75,13.2c.68,4.1,3.75,10.36,8.47,10.81-2.58-9.09,2-20.5,4.38-28.63C257.2,157.71,257,157.54,256.72,157.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.74,178.15a4.67,4.67,0,0,0,2.75,2.25c1.57.45,2.37-1,1.95-2.46-.39-1.34-1.67-3.2-3.26-3a2.1,2.1,0,0,0-1.77,2.38A2.16,2.16,0,0,0,248.74,178.15Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,157.46c5.41,1.29,9.87,3.51,11.25,11.3-1.35-.25-2.47.3-3.93,1.29a11.9,11.9,0,0,0-5.28-5.29c-.62,1.66-1.24,3.31-1.85,5-.34.89-.8,2.93-.8,2.93a34.45,34.45,0,0,0-4.38.35s-1.25-6.55.36-11c.69-1.89,1.53-3.88,3.25-4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,240.47c0,.19,0,.4,0,.6l0,0c-7.7,3.42-22.06-.79-27-2.24,0-.83,0-1.78,0-2.83,2.1-1,4.91-1.72,6.27-2.39a28.74,28.74,0,0,0,12.12-11.1c3.94-6.69,6.13-15.82,3.91-23.27-1-3.33-4.66-5.44-7.7-6.57-1.08-.42-4.81-.76-5.23-1.23h0c0-.28,0-1.3.38-1.21,7.32,1.58,10.1,3.68,12.61,6.36.93,1,4.35,5.54,5.41,6.69C279.35,212.77,269.14,217.23,269.86,240.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,240.47c0,.19,0,.4,0,.6l0,0c-7.7,3.42-22.06-.79-27-2.24,0-.83,0-1.78,0-2.83,2.1-1,4.91-1.72,6.27-2.39a28.74,28.74,0,0,0,12.12-11.1c3.94-6.69,6.13-15.82,3.91-23.27-1-3.33-4.66-5.44-7.7-6.57-1.08-.42-4.81-.76-5.23-1.23h0c0-.28,0-1.3.38-1.21,7.32,1.58,10.1,3.68,12.61,6.36.93,1,4.35,5.54,5.41,6.69C279.35,212.77,269.14,217.23,269.86,240.47Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,287.77s-1.13,3.56-2.89,9a.61.61,0,0,0,0,.11c-1.26,3.85-2.81,8.64-4.5,13.74-3.26,9.85-5,17.6-7.93,25.44-3.38,9.13-23.1,43.59-28.28,52-1.11,1.8-2.14,3.64-3.11,5.53l-1,2-5.1-3.44,1.16-2.72v0c.52-1.38,18-47.17,21.41-59.78,4.54-17,6.93-45.21,12.66-63.57.53-1.72,1.11-3.37,1.72-5,0,0,17.56,14.71,18.56,15.94S252.12,287.77,252.12,287.77Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.71,293.48s4.58,6.1,19.57,6.23l1.25-3.86.94-6.07.5-2.26S237.9,274.5,228.71,293.48Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,394.52l-6.23-3.69c-1.78,2.35-4.94,5.89-4.94,5.89a1.19,1.19,0,0,0,.08,1.56.75.75,0,0,0,.18.13c2.4,1.4,4.59,2.53,7.56,4.33,3.5,2.11,2.38,2,6.46,4.58,2.46,1.54,4.47-1.28,3.5-2.06C207.82,401.69,205.73,396,205.69,394.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11,275.66c-.66,13.59-1,40.42-2.44,54C266,345.32,258,400.2,258,400.2l-6.54-.65s-2.84-43.37.29-65.59c1-6.95-1.62-25.74-2.7-36.93a.31.31,0,0,1,0-.14c-.93-9.5-1.79-17.13-1.79-17.13s-6.74-2.56-10.74-8.28A15.25,15.25,0,0,1,234,266.2a14,14,0,0,1-.42-2.64c-.71-10.87,8.29-20,8.29-20l27.72,5.71S270.44,268.92,270.11,275.66Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,290.89l1,8.41c-.76,1.71,15.12,1.8,20.34-3.9l0-.53-.55-9.2Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,294.94s-18.8-1.43-28.11-.6c-17.65,1.58-20.58-5.69-20.58-5.69s7.64-1.26,10.12-27.69c.59-6.35,5.55-12.78,8.24-15.85a16.16,16.16,0,0,0,2.43-6.39l27,1.62.18,6.81s1,10.21,1.09,12.8C271.39,269.37,270.68,294.94,270.68,294.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,294.94s-18.8-1.43-28.11-.6c-17.65,1.58-20.58-5.69-20.58-5.69s7.64-1.26,10.12-27.69c.59-6.35,5.55-12.78,8.24-15.85a16.16,16.16,0,0,0,2.43-6.39l27,1.62.18,6.81s1,10.21,1.09,12.8C271.39,269.37,270.68,294.94,270.68,294.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,398.72l-7.72,0c-.2,0-.35-.4-.43.68a31.73,31.73,0,0,1-1.39,7.54l-.06.17a1.37,1.37,0,0,0,.87,1.55.59.59,0,0,0,.23,0c2.94,0,5.55-.16,9.22-.1,4.33.07,3.25.66,8.33.83,3.07.09,3.51-4,2.21-4.22C263.94,404.26,259.3,398.7,258.65,398.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,197.87c-2.81-3.32-2.93,20.24,7.67,28.71C273.4,231.78,273.52,214.74,259.23,197.87Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.89,197.75a45.06,45.06,0,0,0,.88,4.46c7.94,24.07,20,18.6,22.42,15.92C281,214,280.7,196,278.81,189l-3.19,1.84c-1.06,2.34-1.12,22.66-3,18.71,0,0-5.78-7.54-6.31-9.78v0a8.43,8.43,0,0,0-7.53-6.49A4.06,4.06,0,0,0,255.89,197.75Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,191.15c-3.14-.76-5-4.08-5-4.08l6.3-4.4.73,6.35Z",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.1 182.68 271.8 187.08 269.17 180.06 274.6 178.56 278.1 182.68",
    style: {
      fill: "#eec8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,180c.1.53.47.9.81.84s.54-.56.44-1.08-.47-.9-.81-.84S263.79,179.47,263.9,180Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.22,410.72h0a2.49,2.49,0,0,1-2.52-1.85l-12.79-49.13H287l3.1,47A4,4,0,0,1,286.22,410.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,410.72h0a2.48,2.48,0,0,1-2.52-1.85l-12.79-49.13h16.08l3.11,47A4,4,0,0,1,343.48,410.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,410.72h0a2.48,2.48,0,0,1-2.52-1.85l-12.79-49.13h16.08l3.11,47A4,4,0,0,1,343.48,410.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,410.72h0a2.48,2.48,0,0,0,2.52-1.85l12.79-49.13H239.63l-3.11,47A4,4,0,0,0,240.4,410.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,410.72h0a2.48,2.48,0,0,0,2.52-1.85l12.79-49.13H239.63l-3.11,47A4,4,0,0,0,240.4,410.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,410.72h0a2.49,2.49,0,0,0,2.52-1.85l12.79-49.13H182.37l-3.1,47A4,4,0,0,0,183.15,410.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.69,285.41l-7.83,70.5c-.53,4.95-5.43,8.77-11.37,8.95H232.24c-7,0-12.41-4.94-11.81-10.67l7.83-70.5c.54-5.07,5.67-9,11.81-9h98.81a3.7,3.7,0,0,1,.47,0C346.08,275,351.28,279.8,350.69,285.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.69,285.41l-7.83,70.5c-.53,4.95-5.43,8.77-11.37,8.95H232.24c-7,0-12.41-4.94-11.81-10.67l7.83-70.5c.54-5.07,5.67-9,11.81-9h98.81a3.7,3.7,0,0,1,.47,0C346.08,275,351.28,279.8,350.69,285.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12,285.41l-7.83,70.5c-.53,4.95-5.43,8.77-11.37,8.95-6.73-.21-11.94-5.05-11.35-10.66l7.84-70.5c.52-4.95,5.42-8.78,11.37-8.95C351.51,275,356.71,279.8,356.12,285.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12,285.41l-7.83,70.5c-.53,4.95-5.43,8.77-11.37,8.95-6.73-.21-11.94-5.05-11.35-10.66l7.84-70.5c.52-4.95,5.42-8.78,11.37-8.95C351.51,275,356.71,279.8,356.12,285.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.01,
    y: 345.71,
    width: 93.82,
    height: 33.05,
    rx: 12.51,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.01,
    y: 345.71,
    width: 93.82,
    height: 33.05,
    rx: 12.51,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.68,
    y: 345.71,
    width: 131.6,
    height: 33.05,
    rx: 12.25,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.68,
    y: 345.71,
    width: 131.6,
    height: 33.05,
    rx: 12.25,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.73 380.1 204.9 396.9 199.47 393.16 204.89 376.44 213.73 380.1",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,308.56a60,60,0,0,1-16.81-2.5h0a15.94,15.94,0,0,1-4.89,10.64l-1.16,1.12s-34.45-8.38-39.17,2.45c-4,9.24-22.82,62.87-22.82,62.87l11.49,5s16.81-23.56,24.53-42.52c.42-1,1.84-6.33,1.84-6.33a101.18,101.18,0,0,0,44.77,8.14c3.4-.16,6.81-2.32,6-13.42A236,236,0,0,0,285.3,308.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,341c-9.63-4.48-22.9-16.51-29.05-21a13.72,13.72,0,0,0-4.81-2.33c5.43-1.07,12.35-.88,18.3-.34l14,6.5,22.52,10.52,2.66,8.06c-1.06,4.31-3.78,4.89-6.22,5a105.07,105.07,0,0,1-28.2-2.7C255.44,344.87,274.41,345.37,265.1,341Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.03 349.12 184.65 361.18 180.01 357.37 189.62 343.46 197.03 349.12",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.91,355.71l5.4,4.29a.64.64,0,0,1,.17.78l-2.88,5.93a1.05,1.05,0,0,1-1.41.5l-.2-.11c-2.2-1.82-4.09-3.52-6.88-5.73-3.29-2.6-2.77-1.55-6.67-4.56-2.35-1.82-.68-4.8.41-4.15,5,3,7.33,2.66,10.35,2.43A2.54,2.54,0,0,1,180.91,355.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,355.45a.13.13,0,0,0,.14,0,.15.15,0,0,0,0-.16c-.11-.26-1.16-2.63-1.95-2.78a.47.47,0,0,0-.42.14h0a.79.79,0,0,0-.23.68c.12.84,1.56,1.71,2.4,2.14Zm-1.78-2.69c.44.16,1.1,1.33,1.53,2.24-1.13-.63-1.83-1.28-1.9-1.75a.47.47,0,0,1,.16-.44.14.14,0,0,1,.15-.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,355.45l0,0a.15.15,0,0,0,.13-.07,3.88,3.88,0,0,0,.76-2.29,1,1,0,0,0-.44-.66h0c-.32-.21-.53-.13-.65,0-.52.46-.25,2.29.09,3A.15.15,0,0,0,178.72,355.45Zm.19-2.85.11.09h0a.67.67,0,0,1,.32.48,3.2,3.2,0,0,1-.57,1.87c-.27-.78-.36-2.13-.05-2.4a.14.14,0,0,1,.18,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,392.35a.15.15,0,0,0,.05-.14.14.14,0,0,0-.11-.12c-.3-.06-2.95-.5-3.53.1a.47.47,0,0,0-.11.44h0a.8.8,0,0,0,.45.59c.8.37,2.37-.37,3.23-.86Zm-3.34,0a5.75,5.75,0,0,1,2.81-.05c-1.19.62-2.15.86-2.6.65a.51.51,0,0,1-.3-.39.21.21,0,0,1,0-.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,392.35l0,0a.14.14,0,0,0,0-.14c0-.06-.64-1.59-1.55-2a1.09,1.09,0,0,0-.83,0h0c-.36.16-.41.38-.39.55.1.71,1.84,1.52,2.62,1.62A.18.18,0,0,0,197.6,392.35Zm-2.36-1.8.14-.05h0a.81.81,0,0,1,.61,0,3.39,3.39,0,0,1,1.29,1.56c-.84-.21-2.05-.9-2.11-1.32,0,0,0-.1.08-.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,307.7a96,96,0,0,0,28.73.57s9.9,38.08-18.38,38c-10.45,0-14.72-4.44-21.44-8.55-15.3-9.35-27.82-23-33.81-22.26-8.62,1.09-3.93,11.39-39.49,39.29l-7.16-6.52s26.88-59.08,44.55-59.08c15.33,0,39.46,23.6,42.69,23.68S276.74,307.7,276.74,307.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,317.63h0a8.22,8.22,0,0,0-4.59,4,25.4,25.4,0,0,0-1.3,5.08c-1,1.42-2.21,3-3.63,4.72C218.61,320,227,317.63,227,317.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.94,392.25l6.53,2.93a.66.66,0,0,1,.38.73l-1.38,6.71a1.09,1.09,0,0,1-1.29.87l-.22-.07c-2.69-1.26-5-2.48-8.39-4-4-1.77-3.18-.85-7.88-2.87-2.83-1.23-1.92-4.66-.65-4.28,5.77,1.76,8.05.8,11-.21A2.63,2.63,0,0,1,199.94,392.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,262.82s-2.16-4.45-.85-5.39,1.07.25,1.07.25l2.73,5.5Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,267.62c-1.22-.18-1.35-1.11-2-2.16,0,0-1.86-4.26-.38-4.89a32.83,32.83,0,0,1,4.64-.16,5,5,0,0,1,4.55,3.85C251.31,268.93,243.13,267.62,243.13,267.62Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.92 267.21 250.9 276.82 256.86 275.74 249.71 266.32 244.92 267.21",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,261s-7.1-.35-9.84,13.51c-2,10.12-2.33,9-2.33,9l-11.33-15.62-6.52,2.62s13.18,26.34,20,24.18c0,0,3.51-.17,6.17-6S275.78,261,275.78,261Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,261s-7.1-.35-9.84,13.51c-2,10.12-2.33,9-2.33,9l-11.33-15.62-6.52,2.62s13.18,26.34,20,24.18c0,0,3.51-.17,6.17-6S275.78,261,275.78,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.07,271.23c-.08,3.27-5.74,10.45.31,15.25C268,289.05,265.79,307,268,310.34c0,0,22.41,3.32,38.28,2.32,1.11-6.46-1.63-19.89,4.18-40.59a8.39,8.39,0,0,0-6.67-10.54c-1.31-.23-2.71-.43-4.14-.6a104.31,104.31,0,0,0-15-1c-1.64,0-3.33.13-4.95.24A11.39,11.39,0,0,0,269.07,271.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,282.83a90.56,90.56,0,0,1,5.33-17.52l.42,3.82,1.26,1.6c-2.09,6.32,8.65,16.84-3.47,31.5a2.1,2.1,0,0,1-2.43.59c-5.09-2.12-10.75-8.71-10.75-8.71l2.67-6.8C294.4,289,296.81,288,297.78,282.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,284.68l4.46.08a1.31,1.31,0,0,0,1.33-1.64l-2.26-11.69a2.16,2.16,0,0,0-2-1.69l-4.45-.08a1.3,1.3,0,0,0-1.34,1.63L270.7,283A2.16,2.16,0,0,0,272.68,284.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,284.68l4.46.08a1.31,1.31,0,0,0,1.33-1.64l-2.26-11.69a2.16,2.16,0,0,0-2-1.69l-4.45-.08a1.3,1.3,0,0,0-1.34,1.63L270.7,283A2.16,2.16,0,0,0,272.68,284.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,284.67l4.46.08a1.31,1.31,0,0,0,1.34-1.64l-2.27-11.69a2.18,2.18,0,0,0-2-1.7l-4.46-.08a1.31,1.31,0,0,0-1.34,1.64L270,283A2.18,2.18,0,0,0,272,284.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,284.67l4.46.08a1.31,1.31,0,0,0,1.34-1.64l-2.27-11.69a2.18,2.18,0,0,0-2-1.7l-4.46-.08a1.31,1.31,0,0,0-1.34,1.64L270,283A2.18,2.18,0,0,0,272,284.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,273.18h-.43a1.44,1.44,0,0,1-1.33-1.14l-.09-.43a.88.88,0,0,1,.9-1.1h.43a1.45,1.45,0,0,1,1.33,1.13l.09.44A.88.88,0,0,1,274,273.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,271.16a.58.58,0,0,0,.55.47.36.36,0,0,0,.37-.45.59.59,0,0,0-.55-.47A.36.36,0,0,0,273,271.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,272.5a.62.62,0,0,0,.56.47.37.37,0,0,0,.37-.46.62.62,0,0,0-.55-.47A.37.37,0,0,0,273.22,272.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.18 283.99 285.02 290.76 288.03 285.98 280.85 280.58 278.18 283.99",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,276.75c.73-3.95.83-12-3.34-13.51-4.87-1.75-6.18,5.61-7.22,12.26s-3.12,14.93-4.71,14.12c-3.32-1.69-9.13-5.52-9.13-5.52l-3.51,5.43s12.24,13.05,17.81,10C307,296.1,309.88,281.76,310.81,276.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,250a25.36,25.36,0,0,0,.11,10.57s-13.43,8.58-13.43-.25c0,0,4.17.5,4.53-4.85C287.31,252.44,290.48,249.36,295.9,250Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.11,255.48c.36-2.8,2.95-5.66,7.65-5.55l.31.29.33.61s-3,7.71-8.81,6.78A8.57,8.57,0,0,0,287.11,255.48Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,239.51c-1,7.29-1.32,10.4-5.32,13.86-6,5.22-14.76,2.35-15.92-5.11-1.05-6.72.83-17.51,8.23-19.85a10,10,0,0,1,13,11.1Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.73,243.52a16.23,16.23,0,0,1-2.43,3.65,2.54,2.54,0,0,0,2.09.57Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,239.83a.35.35,0,0,0,.14-.06.3.3,0,0,0,.06-.41h0a3.41,3.41,0,0,0-2.82-1.4.31.31,0,0,0-.27.32.3.3,0,0,0,.31.26,2.9,2.9,0,0,1,2.33,1.18A.29.29,0,0,0,289.24,239.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,238.47a.24.24,0,0,0,.14-.05,2.85,2.85,0,0,1,2.55-.47.29.29,0,0,0,.38-.16h0a.29.29,0,0,0-.17-.38,3.43,3.43,0,0,0-3.11.53.3.3,0,0,0-.08.41.29.29,0,0,0,.29.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,242.88c0,.59-.4,1.05-.79,1s-.67-.54-.62-1.14.41-1,.79-1S287.07,242.28,287,242.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,242.33c0,.6-.41,1.06-.79,1s-.67-.54-.62-1.14.4-1.05.79-1S280.33,241.73,280.28,242.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.82,241.24l-1.39-.52S279.07,241.89,279.82,241.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.57,241.79l-1.4-.53S285.82,242.44,286.57,241.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.18,248.85a4.81,4.81,0,0,0,.44-.57.15.15,0,0,0,0-.2h0a.15.15,0,0,0-.2,0,3.89,3.89,0,0,1-3,1.81.14.14,0,0,0,0,.28A4,4,0,0,0,286.18,248.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.37,226.79s11.48-2.23,14.14,16.44c1.33,9.3-11.34,14.51-11.34,14.51V255.8a20.63,20.63,0,0,1,1.67-8.12l.84-2L292.16,238s-3.29-1-3.75-4.1c0,0-.78,1.09.46,3.08,0,0-8.42.33-8-4a2.66,2.66,0,0,0-.05,2.35s-2.62-.05-2.3-2.34S280.9,221.12,292.37,226.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24,245.44a5.37,5.37,0,0,1-2.84,3c-1.74.75-2.86-.74-2.58-2.51.24-1.59,1.44-3.89,3.28-3.89a2.42,2.42,0,0,1,2.14,3.43Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,281.56l1,1.64a2.23,2.23,0,0,0,1.75,1.06l3.37.24A4.12,4.12,0,0,0,282,283l.54-.64c-1.48-2.84-5.17-4.81-5.17-4.81l-1-.68a1.88,1.88,0,0,0-2.62.42l-1.37,1.94A2.14,2.14,0,0,0,272.33,281.56Z",
    style: {
      fill: "#7f3e3b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.37,175.54l-14.65,2.2-8.49-21.68c-.36-1.26-1.88.56-3.17.35l-2.22-.36c-.21-.41,4.09,18.58,6.94,29.76,1.16,4.57,24.55-.37,24.55-.37C134.43,181.34,122.37,175.54,122.37,175.54Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,175a45.24,45.24,0,0,0,3.92,13.69,1.36,1.36,0,0,0,1.3.76c7.45-.46,10.72-2.24,10.72-2.24-.67-2.24,2.31-14.55.77-16.16a29.54,29.54,0,0,0-6.12,1.76C122.54,173.66,113.65,175,113.65,175Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,188.37c.09,20.64-1.73,38.36-1.73,38.36s35.75.15,37,.18c2.88-23.91,4.95-30,5.7-44.58.37-6-3-11.34-6.49-12l-.65-.08c-10-1.33-20.82-.26-30.88.8h0C126.51,171.58,127.82,178.67,127.45,188.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76,330c-3,27.44-.56,76.58-.56,76.58l6.28.17s4.79-45.52,5-78.27Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76,330c-3,27.44-.56,76.58-.56,76.58l6.28.17s4.79-45.52,5-78.27Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.89,403.58c4.65,2.65,5.17,2.71,10.29,3.76,1.12.23.7,2.9-1.91,2.93-4.31.07-4-.08-7.64,0-3.14,0-7.69.21-10.19.27h-.08a1.08,1.08,0,0,1-1-1.12l.46-5.76a.51.51,0,0,1,.49-.45l8-.06A3.17,3.17,0,0,1,150.89,403.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,403.68c1,.2,2.88.44,3.57-.2a.88.88,0,0,0,.27-.76h0a.56.56,0,0,0-.27-.41c-.79-.42-3.34.92-3.62,1.08a.18.18,0,0,0-.08.16.16.16,0,0,0,.11.12Zm3.43-1.09a.18.18,0,0,1,.1.15.54.54,0,0,1-.17.5c-.39.36-1.44.44-2.86.21,1-.5,2.39-1.06,2.87-.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,403.68c.76-.36,2.27-1.77,2.12-2.52,0-.18-.16-.39-.58-.43h0a1.09,1.09,0,0,0-.84.28,4.38,4.38,0,0,0-.92,2.51.17.17,0,0,0,.07.15h0A.14.14,0,0,0,150.56,403.68Zm1.68-2.6c.13,0,.14.11.15.14.07.45-.93,1.56-1.72,2.06a3.67,3.67,0,0,1,.8-2,.75.75,0,0,1,.62-.2h.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,331.61c-3.9,27.32-18.38,74.35-18.38,74.35l-6.88-.14s6.61-45.28,14.47-77.08Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,403.29c-4.85,2.76-5.39,2.82-10.72,3.92-1.17.24-.74,3,2,3.05,4.5.07,4.12-.09,8-.05,3.27,0,8,.22,10.61.29h.09a1.12,1.12,0,0,0,1-1.17l-.48-6a.52.52,0,0,0-.51-.46l-8.29-.07A3.28,3.28,0,0,0,93,403.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,403.38a.14.14,0,0,0,.11-.12.16.16,0,0,0-.08-.17c-.29-.16-2.94-1.55-3.77-1.12a.56.56,0,0,0-.28.43h0a.9.9,0,0,0,.28.78c.72.67,2.64.43,3.72.22Zm-3.53-1.16c.5-.16,1.95.42,3,.94-1.48.23-2.58.15-3-.22a.58.58,0,0,1-.18-.52.18.18,0,0,1,.1-.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,403.38h0a.15.15,0,0,0,.07-.15,4.52,4.52,0,0,0-1-2.62,1.16,1.16,0,0,0-.87-.29h0c-.44.05-.57.27-.6.45-.15.79,1.41,2.25,2.21,2.63A.14.14,0,0,0,93.43,403.38Zm-1.86-2.72h.16a.83.83,0,0,1,.64.21A3.84,3.84,0,0,1,93.2,403c-.82-.52-1.87-1.68-1.78-2.14,0,0,0-.11.14-.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24,273.48c-3.11,5.62-19.11,61.62-19.11,61.62l-7,32.51a123.47,123.47,0,0,0-2.23,14.26l-1.4,10.39-16.15.2c.33-1.41,3.34-15.76,10.39-60.89,7.26-46.43,20.68-104.68,20.68-104.68s20.58-.8,29.44.56C157.34,240,147,261.4,140.24,273.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.71,257.15S130.43,289,132,298.29l11.38-36.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9,392.46c.37-.56,2.52-46.23,3.34-59.17l6.2-71.81s3.5-23.89.24-34.57l-30.07-.21s8.08,87.92,6.25,132.25c-.69,16.54-1.06,33.52-1.06,33.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46,170.09c2.25,1.6,1.29,4.12-.54,6.18a20.34,20.34,0,0,1-7.78,5.62c-.06,0-9.92-7.15-2.95-11.61,1.15-.74,1.6-2.49,1.73-4.32a21.68,21.68,0,0,0-.17-4.18,10.2,10.2,0,0,0-.15-1,8.36,8.36,0,0,0-.2-1l10.45-4.32c-1.15,1.73-2,7.27-1.78,9.06C150.34,166.56,150.42,169.35,151.46,170.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,165.92a21.68,21.68,0,0,0-.17-4.18,10,10,0,0,0-.14-1l8.08-1.55C148,160.86,145.65,164.3,142,165.92Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06,155.73c1.3,7.07,9.77,10.8,15.36,5.73,3.23-2.92,3.74-6.4,4.33-11.83.1-.83.19-1.69.29-2.61a9.61,9.61,0,0,0-.43-4.26,8.35,8.35,0,0,0-.73-1.64,9.64,9.64,0,0,0-11.49-4.44C133.38,139.05,131.88,149.36,133.06,155.73Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,147.22c-.37,0-.7.43-.73,1s.2,1.05.62,1.07.74-.42.77-1S142.18,147.25,141.81,147.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.46,147.17c-.37,0-.7.41-.73,1s.24,1,.62,1.07.7-.42.73-1S135.83,147.19,135.46,147.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13,153.83a5.33,5.33,0,0,1-3.41-1.17,21.61,21.61,0,0,0,3.71-4.4Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,146.66a2.71,2.71,0,0,0-2.16-1.12h-.11a.35.35,0,0,1-.32-.35.34.34,0,0,1,.36-.32,3.35,3.35,0,0,1,2.73,1.36.34.34,0,0,1-.06.47.25.25,0,0,1-.16.06A.34.34,0,0,1,144,146.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,144.31h0a.34.34,0,0,1,.34-.34,3.31,3.31,0,0,1,2.73,1.35h0a.32.32,0,0,1-.1.45h0a.32.32,0,0,1-.44-.11,2.65,2.65,0,0,0-2.17-1,.3.3,0,0,1-.28-.14A.33.33,0,0,1,133.14,144.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.38,142.38a12.45,12.45,0,0,1,.42,4.38,9.5,9.5,0,0,1,1.89,7.78,8.37,8.37,0,0,1,4.62-3.64,32.11,32.11,0,0,0,.8-8,6.9,6.9,0,0,0-.58-3,2.75,2.75,0,0,0-2.45-1.61c.12-1.07-.88-2-1.8-2.52a16.8,16.8,0,0,0-17.95.49c-.82,0-1.68,0-2.51,0a6.76,6.76,0,0,0,2.83,4.56,5.18,5.18,0,0,1,.89.92,11.33,11.33,0,0,0,5.64.2,54.34,54.34,0,0,1,5.63-1A2.54,2.54,0,0,1,148.38,142.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3,149.21c-2.29,0-3.69,2.93-3.93,4.9-.28,2.2,1.19,4,3.31,3a6.54,6.54,0,0,0,3.42-3.75A3,3,0,0,0,153.3,149.21Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.33,155.78s2-.8,7.73-1.49c-.33,2.1-1.59,3-4.56,3.3S136.33,155.78,136.33,155.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59,155.7a1.39,1.39,0,0,0,1.08.89,26,26,0,0,0,5-1.11,1.51,1.51,0,0,0,1.13-1.14A41.16,41.16,0,0,0,136.59,155.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.79,156.42a15.17,15.17,0,0,1,4.56-1.07,2.47,2.47,0,0,1,1.21.49c-.64,1-1.92,1.55-4,1.79a3.36,3.36,0,0,1-2.3-.42A3.18,3.18,0,0,1,137.79,156.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.66,153.56s-1.93-4.82-.49-5.71,1.1.34,1.1.34l2.45,6Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,158.33c-1.27-.28-1.33-1.26-1.91-2.42,0,0-1.63-4.59,0-5.14a35.25,35.25,0,0,1,4.88.17,5.27,5.27,0,0,1,4.48,4.39C100.15,160.32,91.67,158.33,91.67,158.33Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.17 178.04 165.77 203.96 170.29 179.07 160.17 178.04",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91,179.19c.84,2.25,1.63,4.51,2.39,6.79s1.49,4.56,2.2,6.85,1.39,4.6,2.07,6.91a15.25,15.25,0,0,1,.89,5.38,11.69,11.69,0,0,1-.52,3,19.17,19.17,0,0,1-.82,2.2l-.2.46,0,0q-3.39,5.83-6.89,11.59c-1.17,1.92-2.31,3.86-3.52,5.77s-2.37,3.82-3.6,5.71a2.91,2.91,0,0,1-5.17-2.62c.79-2.11,1.64-4.19,2.47-6.29s1.71-4.16,2.56-6.24q2.56-6.24,5.26-12.42l-.22.49a7.93,7.93,0,0,0,.3-1.23,1.07,1.07,0,0,0,0-.57l-.17-.45-.48-1.17c-.89-2.25-1.77-4.5-2.62-6.77s-1.68-4.53-2.48-6.81-1.57-4.58-2.3-6.88a5.75,5.75,0,0,1,10.88-3.73Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,230.43l-4,5s3.36,5.22,5.59,4.47,3-6.71,3-6.71Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.06,170.68s-7.33,1.2-1.73,15.74c4.36,11.34,4.69,9.71,4.69,9.71l11-6.44S173,170.12,163.06,170.68Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-4--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,113.53H350.64a2.46,2.46,0,0,0-2.46,2.46v13.69a2.47,2.47,0,0,0,2.46,2.46h7.44l.3,5.08a2,2,0,0,0,3.38.14l3.17-5.22h35a2.47,2.47,0,0,0,2.46-2.46V116A2.47,2.47,0,0,0,400,113.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,113.53H350.64a2.46,2.46,0,0,0-2.46,2.46v13.69a2.47,2.47,0,0,0,2.46,2.46h7.44l.3,5.08a2,2,0,0,0,3.38.14l3.17-5.22h35a2.47,2.47,0,0,0,2.46-2.46V116A2.47,2.47,0,0,0,400,113.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "358.13 127.09 359.3 124.72 361.93 124.33 360.03 122.48 360.48 119.87 358.13 121.11 355.79 119.87 356.23 122.48 354.34 124.33 356.96 124.72 358.13 127.09",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.95 127.09 368.12 124.72 370.74 124.33 368.85 122.48 369.29 119.87 366.95 121.11 364.6 119.87 365.05 122.48 363.15 124.33 365.78 124.72 366.95 127.09",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.77 127.09 376.94 124.72 379.56 124.33 377.66 122.48 378.11 119.87 375.77 121.11 373.42 119.87 373.87 122.48 371.97 124.33 374.59 124.72 375.77 127.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.58 127.09 385.76 124.72 388.38 124.33 386.48 122.48 386.93 119.87 384.58 121.11 382.24 119.87 382.69 122.48 380.79 124.33 383.41 124.72 384.58 127.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.4 127.09 394.57 124.72 397.2 124.33 395.3 122.48 395.75 119.87 393.4 121.11 391.06 119.87 391.5 122.48 389.61 124.33 392.23 124.72 393.4 127.09",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.11,126.65h49.3a2.48,2.48,0,0,1,2.47,2.47v13.69a2.47,2.47,0,0,1-2.47,2.46H266l-.29,5.08a2,2,0,0,1-3.38.13l-3.18-5.21h-35a2.47,2.47,0,0,1-2.47-2.46V129.12A2.48,2.48,0,0,1,224.11,126.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.11,126.65h49.3a2.48,2.48,0,0,1,2.47,2.47v13.69a2.47,2.47,0,0,1-2.47,2.46H266l-.29,5.08a2,2,0,0,1-3.38.13l-3.18-5.21h-35a2.47,2.47,0,0,1-2.47-2.46V129.12A2.48,2.48,0,0,1,224.11,126.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "231.32 132.19 232.49 134.56 235.12 134.94 233.22 136.79 233.66 139.4 231.32 138.17 228.97 139.4 229.42 136.79 227.52 134.94 230.15 134.56 231.32 132.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.14 132.19 241.31 134.56 243.93 134.94 242.03 136.79 242.48 139.4 240.14 138.17 237.79 139.4 238.24 136.79 236.34 134.94 238.96 134.56 240.14 132.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.95 132.19 250.13 134.56 252.75 134.94 250.85 136.79 251.3 139.4 248.95 138.17 246.61 139.4 247.06 136.79 245.16 134.94 247.78 134.56 248.95 132.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.77 132.19 258.94 134.56 261.57 134.94 259.67 136.79 260.12 139.4 257.77 138.17 255.43 139.4 255.87 136.79 253.98 134.94 256.6 134.56 257.77 132.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.59 132.19 267.76 134.56 270.38 134.94 268.49 136.79 268.94 139.4 266.59 138.17 264.24 139.4 264.69 136.79 262.79 134.94 265.42 134.56 266.59 132.19",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.38,316.69h49.31a2.47,2.47,0,0,0,2.46-2.46V300.54a2.46,2.46,0,0,0-2.46-2.46h-7.44L282,293a2,2,0,0,0-3.38-.13l-3.17,5.22h-35a2.46,2.46,0,0,0-2.46,2.46v13.69A2.47,2.47,0,0,0,240.38,316.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.38,316.69h49.31a2.47,2.47,0,0,0,2.46-2.46V300.54a2.46,2.46,0,0,0-2.46-2.46h-7.44L282,293a2,2,0,0,0-3.38-.13l-3.17,5.22h-35a2.46,2.46,0,0,0-2.46,2.46v13.69A2.47,2.47,0,0,0,240.38,316.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "247.86 303.12 249.04 305.5 251.66 305.88 249.76 307.73 250.21 310.34 247.86 309.11 245.52 310.34 245.97 307.73 244.07 305.88 246.69 305.5 247.86 303.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.68 303.12 257.85 305.5 260.48 305.88 258.58 307.73 259.03 310.34 256.68 309.11 254.34 310.34 254.78 307.73 252.88 305.88 255.51 305.5 256.68 303.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.5 303.12 266.67 305.5 269.29 305.88 267.4 307.73 267.84 310.34 265.5 309.11 263.15 310.34 263.6 307.73 261.7 305.88 264.32 305.5 265.5 303.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.32 303.12 275.49 305.5 278.11 305.88 276.21 307.73 276.66 310.34 274.32 309.11 271.97 310.34 272.42 307.73 270.52 305.88 273.14 305.5 274.32 303.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.13 303.12 284.31 305.5 286.93 305.88 285.03 307.73 285.48 310.34 283.13 309.11 280.79 310.34 281.24 307.73 279.34 305.88 281.96 305.5 283.13 303.12",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.81,105.66h50.66a2.47,2.47,0,0,1,2.47,2.46v13.69a2.47,2.47,0,0,1-2.47,2.46H136.73l-3.08,5.08a2,2,0,0,1-3.38.14l-3.18-5.22H103.8a2.47,2.47,0,0,1-2.46-2.46V108.12A2.47,2.47,0,0,1,103.81,105.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.81,105.66h50.66a2.47,2.47,0,0,1,2.47,2.46v13.69a2.47,2.47,0,0,1-2.47,2.46H136.73l-3.08,5.08a2,2,0,0,1-3.38.14l-3.18-5.22H103.8a2.47,2.47,0,0,1-2.46-2.46V108.12A2.47,2.47,0,0,1,103.81,105.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.23 110.87 113.41 113.24 116.03 113.63 114.13 115.47 114.58 118.09 112.23 116.85 109.89 118.09 110.34 115.47 108.44 113.63 111.06 113.24 112.23 110.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.05 110.87 122.22 113.24 124.85 113.63 122.95 115.47 123.4 118.09 121.05 116.85 118.71 118.09 119.15 115.47 117.26 113.63 119.88 113.24 121.05 110.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.87 110.87 131.04 113.24 133.66 113.63 131.77 115.47 132.22 118.09 129.87 116.85 127.52 118.09 127.97 115.47 126.07 113.63 128.7 113.24 129.87 110.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.69 110.87 139.86 113.24 142.48 113.63 140.59 115.47 141.03 118.09 138.69 116.85 136.34 118.09 136.79 115.47 134.89 113.63 137.51 113.24 138.69 110.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.5 110.87 148.68 113.24 151.3 113.63 149.4 115.47 149.85 118.09 147.5 116.85 145.16 118.09 145.61 115.47 143.71 113.63 146.33 113.24 147.5 110.87",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4ae9526b915f70dffb54ea8f17cdf703.svg";
export { ForwardRef as ReactComponent };